// Measure the banner and header heights and set CSS variables used by CSS.
// It runs on load and resize, and throttles resize updates.
// (Original theme util, preserved verbatim; the build appends the Find Your Fit
//  quiz after this so the theme's site-wide banner-height.js also loads the quiz.)

(function () {
  function setHeights() {
    var banner = document.querySelector(".site-header-banner");
    var header = document.querySelector(
      "header.fixed-top, header, .site-header, .main-header, .fixed-top, #Header"
    );
    var bannerHeight = banner ? Math.round(banner.offsetHeight) : 0;
    var headerHeight = header ? Math.round(header.offsetHeight) : 0;

    document.documentElement.style.setProperty(
      "--banner-height",
      bannerHeight + "px"
    );
    document.documentElement.style.setProperty(
      "--site-header-height",
      headerHeight + "px"
    );
    document.documentElement.style.setProperty(
      "--header-and-banner-height",
      bannerHeight + headerHeight + "px"
    );
  }

  function throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  document.addEventListener("DOMContentLoaded", function () {
    setHeights();

    var imgs = document.querySelectorAll(".site-header-banner img");
    if (imgs.length) {
      var loaded = 0;
      imgs.forEach(function (img) {
        if (img.complete) {
          loaded++;
        } else {
          img.addEventListener("load", setHeights);
          img.addEventListener("error", setHeights);
        }
      });
      if (loaded === imgs.length) setHeights();
    }
  });

  window.addEventListener("resize", throttle(setHeights, 150));
})();


/* Educated Beards - Find Your Fit. GENERATED by scripts/build-fyf.js from
   find-your-fit/*.html. Do not edit here; edit the source and redeploy. */
(function(){
  if(window.__fyfBooted){return;}window.__fyfBooted=true;
  function addStyle(c){var s=document.createElement('style');s.textContent=c;(document.head||document.documentElement).appendChild(s);}
  function boot(){
    addStyle("#fyf-root{\n      --fyf-ink:#1c1c1a;\n      --fyf-card:#fffdf8;\n      --fyf-forest:#22302a;\n      --fyf-gold:#b08d3d;\n      --fyf-line:#e4dccb;\n      --fyf-muted:#6b6459;\n      --fyf-radius:14px;\n      --fyf-serif:\"Playfair Display\",Georgia,\"Times New Roman\",serif;\n      --fyf-sans:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Helvetica,Arial,sans-serif;\n      max-width:720px;margin:0 auto;padding:28px 20px 64px;\n      font-family:var(--fyf-sans);color:var(--fyf-ink);-webkit-font-smoothing:antialiased;\n    }\n    #fyf-root *{box-sizing:border-box}\n    .fyf-stage{background:var(--fyf-card);border:1px solid var(--fyf-line);\n      border-radius:var(--fyf-radius);padding:34px 30px;box-shadow:0 14px 40px -24px rgba(28,28,26,.4)}\n    .fyf-kicker{font-size:12px;letter-spacing:.18em;text-transform:uppercase;color:var(--fyf-gold);font-weight:700;margin:0 0 6px}\n    .fyf-progwrap{margin:0 0 26px}\n    .fyf-progbar{height:6px;background:var(--fyf-line);border-radius:99px;overflow:hidden}\n    .fyf-progfill{height:100%;width:0;background:var(--fyf-forest);transition:width .35s ease}\n    .fyf-progtext{font-size:12px;color:var(--fyf-muted);margin-top:8px}\n    .fyf-q{font-family:var(--fyf-serif);font-size:27px;line-height:1.22;margin:0 0 22px;font-weight:600}\n    .fyf-sub{color:var(--fyf-muted);font-size:15px;margin:-14px 0 22px}\n    .fyf-opts{display:grid;gap:12px}\n    .fyf-opt{display:flex;align-items:center;justify-content:space-between;gap:14px;text-align:left;width:100%;cursor:pointer;\n      background:#fff;border:1.5px solid var(--fyf-line);border-radius:11px;padding:17px 20px;font-size:16px;color:var(--fyf-ink);\n      transition:border-color .15s ease,transform .05s ease,background .15s ease}\n    .fyf-opt:hover{border-color:var(--fyf-gold);background:#fffdf5}\n    .fyf-opt:active{transform:scale(.995)}\n    .fyf-opt-note{font-size:13px;color:var(--fyf-muted);margin-top:3px}\n    .fyf-chev{color:var(--fyf-line);font-size:20px;flex:0 0 auto;transition:color .15s ease}\n    .fyf-opt:hover .fyf-chev{color:var(--fyf-gold)}\n    .fyf-nav{display:flex;justify-content:space-between;align-items:center;margin-top:24px}\n    .fyf-back{background:none;border:none;color:var(--fyf-muted);cursor:pointer;font-size:14px;padding:6px 2px}\n    .fyf-back:hover{color:var(--fyf-ink)}\n    .fyf-back[disabled]{opacity:0;pointer-events:none}\n    .fyf-result-badge{display:inline-block;font-size:12px;letter-spacing:.16em;text-transform:uppercase;color:#fff;\n      background:var(--fyf-forest);padding:6px 12px;border-radius:99px;margin-bottom:14px;font-weight:700}\n    .fyf-result-h{font-family:var(--fyf-serif);font-size:30px;line-height:1.18;margin:0 0 10px;font-weight:700}\n    .fyf-result-p{color:var(--fyf-muted);font-size:16px;line-height:1.55;margin:0 0 22px}\n    .fyf-hero{width:100%;height:200px;object-fit:cover;border-radius:11px;margin:0 0 24px;display:block}\n    .fyf-rec{display:flex;gap:16px;align-items:center;border:1px solid var(--fyf-line);border-radius:12px;padding:16px;background:#fff;margin-bottom:10px}\n    .fyf-rec-img{width:78px;height:78px;border-radius:9px;object-fit:cover;flex:0 0 auto;background:#f2ede2}\n    .fyf-rec-body h4{margin:0 0 4px;font-family:var(--fyf-serif);font-size:19px}\n    .fyf-rec-body p{margin:0;color:var(--fyf-muted);font-size:14px}\n    .fyf-rec-price{margin-left:auto;font-weight:700;font-size:18px;white-space:nowrap}\n    .fyf-edu{font-size:13.5px;color:var(--fyf-muted);border-left:2px solid var(--fyf-gold);padding:3px 0 3px 13px;margin:0 0 18px;line-height:1.55}\n    .fyf-trust{font-size:13px;color:var(--fyf-muted);text-align:center;margin:0 0 22px}\n    .fyf-form{display:grid;gap:12px}\n    .fyf-input{width:100%;padding:15px 16px;font-size:16px;border:1.5px solid var(--fyf-line);border-radius:11px;font-family:inherit;background:#fff}\n    .fyf-input:focus{outline:none;border-color:var(--fyf-gold)}\n    .fyf-btn{width:100%;padding:16px;font-size:16px;font-weight:700;cursor:pointer;background:var(--fyf-forest);color:#fff;border:none;border-radius:11px;letter-spacing:.02em;transition:background .15s ease}\n    .fyf-btn:hover{background:#2c4038}\n    .fyf-btn.secondary{background:transparent;color:var(--fyf-forest);border:1.5px solid var(--fyf-line)}\n    .fyf-btn.secondary:hover{background:#faf7ef;border-color:var(--fyf-gold)}\n    .fyf-consent{font-size:12px;color:var(--fyf-muted);text-align:center;line-height:1.5;margin:2px 0 0}\n    .fyf-err{color:#a03434;font-size:13px;min-height:16px}\n    /* trigger + modal */\n    .fyf-trigger{display:inline-flex;align-items:center;background:var(--fyf-forest);color:#fff;border:none;border-radius:11px;\n      padding:15px 28px;font-size:16px;font-weight:700;letter-spacing:.02em;cursor:pointer;font-family:var(--fyf-sans)}\n    .fyf-trigger:hover{background:#2c4038}\n    .fyf-overlay{position:fixed;inset:0;background:rgba(20,20,18,.72);z-index:99999;\n      display:flex;align-items:flex-start;justify-content:center;padding:24px;overflow-y:auto}\n    .fyf-overlay[hidden]{display:none}\n    .fyf-modal{position:relative;width:100%;max-width:660px;margin:auto}\n    .fyf-close{position:absolute;top:14px;right:14px;z-index:3;width:34px;height:34px;border-radius:50%;border:none;\n      background:rgba(0,0,0,.06);color:var(--fyf-ink);font-size:22px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center}\n    .fyf-close:hover{background:rgba(0,0,0,.12)}\n    @media (max-width:520px){.fyf-stage{padding:26px 20px}.fyf-q{font-size:23px}.fyf-result-h{font-size:25px}.fyf-overlay{padding:0}.fyf-modal{max-width:none}.fyf-stage{border-radius:0;min-height:100vh}}");
    addStyle(".fyf-entry{ --gold:#c7a368; --ink:#1c1c1a; text-align:center; margin-top:4px; }\n  .fyf-entry *{ box-sizing:border-box; }\n  /* Beard | Hair | Shave — inherits your theme font, one step smaller than the\n     title, kept close under it. Strong shadow so it reads on snow or grey. */\n  .fyf-entry-cats{\n    font-family:inherit; font-size:clamp(19px,3vw,28px); letter-spacing:.04em;\n    margin:0 0 14px; display:flex; align-items:center; justify-content:center; gap:.6em; flex-wrap:wrap;\n  }\n  .fyf-entry-cats a{ color:#fff; text-decoration:none; padding:2px 4px; transition:color .15s ease; text-shadow:0 2px 14px rgba(0,0,0,.9), 0 1px 3px rgba(0,0,0,.95); }\n  .fyf-entry-cats a:hover{ color:var(--gold); }\n  .fyf-entry-cats span{ color:var(--gold); opacity:.7; font-size:.8em; }\n  /* Button — on-brand gold, dark text, inherits the site font */\n  .fyf-entry-cta{\n    appearance:none; cursor:pointer; font:inherit; font-weight:700;\n    font-size:clamp(15px,2vw,17px); letter-spacing:.06em; text-transform:uppercase;\n    color:var(--ink); background:var(--gold); border:none; border-radius:10px;\n    padding:16px 42px; box-shadow:0 12px 34px -14px rgba(0,0,0,.65);\n    transition:background .15s ease, transform .05s ease;\n  }\n  .fyf-entry-cta:hover{ background:#d3b079; }\n  .fyf-entry-cta:active{ transform:scale(.99); }\n  @media (max-width:520px){\n    .fyf-entry-cats{ gap:.5em; margin-bottom:12px; }\n    .fyf-entry-cta{ width:100%; max-width:340px; padding:16px; }\n  }\n  /* Always-visible \"Take the Quiz\" pill (bottom-center) */\n  #fyf-sticky{\n    position:fixed; left:50%; bottom:18px; transform:translateX(-50%); z-index:9998;\n    appearance:none; cursor:pointer; border:none; font-family:inherit; font-weight:700;\n    font-size:14px; letter-spacing:.06em; text-transform:uppercase;\n    color:#1c1c1a; background:#c7a368; border-radius:999px; padding:13px 28px;\n    box-shadow:0 10px 30px -8px rgba(0,0,0,.55); transition:background .15s ease;\n  }\n  #fyf-sticky:hover{ background:#d3b079; }\n  @media (max-width:520px){ #fyf-sticky{ bottom:14px; font-size:13px; padding:12px 22px; } }");
    var d=document.createElement('div');d.innerHTML="<div id=\"fyf-root\">\n  \n  \n  \n\n  \n  <div class=\"fyf-overlay\" id=\"fyf-overlay\" hidden>\n    <div class=\"fyf-modal\" role=\"dialog\" aria-modal=\"true\" aria-label=\"Find Your Fit\">\n      <button type=\"button\" class=\"fyf-close\" id=\"fyf-close\" aria-label=\"Close\">&times;</button>\n      <div class=\"fyf-stage\" id=\"fyf-stage\" aria-live=\"polite\"></div>\n    </div>\n  </div>\n</div>";
    while(d.firstChild){document.body.appendChild(d.firstChild);}
    try{ (function(){ (function(){
  "use strict";

  /* =========================================================================
     CONFIG  — the only part you edit
     ========================================================================= */
  var CONFIG = {
    storeUrl: "https://educatedbeards.ca",
    klaviyo: {
      companyId:"RX3GLn",          // EB Klaviyo public key (site ID) — live
      listId:"V2GFvM",             // default list = "Newsletter" (single opt-in), so leads capture right away
      // OPTIONAL hard-divided lists: paste a Klaviyo list ID to send that audience
      // to its own list. Left blank = everyone lands in listId above, and you divide
      // them with SEGMENTS off the FYF_Audience / FYF_Focus / FYF_ForWho properties.
      lists:{ beard:"", shave:"", hair:"", full:"", gift:"" }
    },
    metaPixelId: "",
    incentive: "",                           // TODO 3: e.g. "and get 10% off" — leave "" for no offer
    // Intro lifestyle hero (Kevin's study photo), hosted on Shopify Files.
    heroImage: "https://cdn.shopify.com/s/files/1/0308/0880/1417/files/fyf-intro-hero_jpg.png?v=1785862509",
    // Anonymous analytics endpoint (eb-app on Heroku). Powers the A/B test and the
    // quarterly self-improving review. Confirm this matches your app's live domain.
    trackUrl: "https://mysterious-wave-90502.herokuapp.com/api/fyf/event"
  };

  var SCENTS = {
    bg:{label:"Bergamot & Grapefruit", note:"Bright citrus. The one that built the brand."},
    be:{label:"Balsam Eclipse",        note:"The woods after dark. Deep and calm."},
    sm:{label:"Smoke & Moss",          note:"Campfire smoke over damp forest floor. Our boldest."},
    pc:{label:"Peppermint Cedarwood",  note:"Cool, sharp, a little woodsy."},
    un:{label:"Keep it unscented",     note:"No scent. Just the good stuff."}
  };

  /* Real EB products, by scent. Handle -> /products/<handle>.
     No handle for a scent -> route to the collection page instead. */
  var CDN = "https://cdn.shopify.com/s/files/1/0308/0880/1417/";
  var PRODUCTS = {
    // `img` = the photo shown on the result screen. These are your live Shopify
    // product photos. To use a nicer shot, host it (Shopify > Content > Files) and
    // paste its URL over the img below. <== marks the two Kevin just supplied.
    // Every scent maps to a full-price kit. NEVER show a "from $X" collection
    // minimum (that read like wholesale). Fallbacks are also full-price kits.
    beardKit:{ collection:"beard", fallback:{title:"Beard Maintenance Kit", price:"$79", variantId:"41863128875158", handle:"3-product-bundle-oil-wash-butter-1", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
      byScent:{ bg:{title:"Bergamot Grapefruit Beard Kit", price:"$79", variantId:"41863128875158", handle:"3-product-bundle-oil-wash-butter-1", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
                be:{title:"Balsam Eclipse Beard Kit",       price:"$79", variantId:"42123154522262", handle:"balsam-eclipse-beard-maintenance-kit", img:CDN+"files/fyf-rec-beardkit-be.pngfyf-rec-beardkit-be.png?v=1785862509"},
                sm:{title:"Smoke & Moss Beard Kit",         price:"$79", variantId:"42897248878742", handle:"smoke-moss-beard-maintenance-kit", img:CDN+"files/SmokeandMoss_Smokebackground.png?v=1700101619"},
                pc:{title:"Peppermint Cedarwood Beard Kit", price:"$79", variantId:"41868509380758", handle:"3-product-bundle-oil-wash-butter-peppermint-cedarwood", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Beard Kit",            price:"$79", variantId:"42123162484886", handle:"unscented-beard-maintenance-kit", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    book:{ collection:"gifts", fallback:{title:"The Book of Beards®", price:"$199", variantId:"32942285258889", handle:"bergamot-grapefruit-6", img:CDN+"products/BG_Book_Contents-min.png?v=1587402950"},
      byScent:{ bg:{title:"Bergamot Grapefruit Book of Beards®", price:"$199", variantId:"32942285258889", handle:"bergamot-grapefruit-6", img:CDN+"products/BG_Book_Contents-min.png?v=1587402950"},
                be:{title:"Balsam Eclipse Book of Beards®",       price:"$199", variantId:"32942285750409", handle:"balsam-eclipse-6", img:CDN+"products/BE_Book_Contents-min.png?v=1610351939"},
                sm:{title:"Smoke & Moss Book of Beards®",         price:"$199", variantId:"43712664469654", handle:"smoke-moss-book-of-beards", img:CDN+"files/SM_Book_Front.png?v=1717435788"},
                pc:{title:"Peppermint Cedarwood Book of Beards®", price:"$199", variantId:"32942285586569", handle:"peppermint-cedarwood-2", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Book of Beards®",            price:"$199", variantId:"40595505905814", handle:"unscented-3", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    shaveKit:{ collection:"shave-1", fallback:{title:"Shave Kit (5 pieces)", price:"$114", variantId:"45634497478806", handle:"bergamot-grapefruit-shave-kit-5-pieces", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"},
      byScent:{ bg:{title:"Bergamot & Grapefruit Shave Kit", price:"$114", variantId:"45634497478806", handle:"bergamot-grapefruit-shave-kit-5-pieces", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"},
                be:{title:"Balsam Eclipse Shave Kit",         price:"$114", variantId:"45634474442902", handle:"balsam-eclipse-shave-kit-5-pieces", img:CDN+"files/ShaveKit-BalsamEclipse1.png?v=1758355366"},
                sm:{title:"Smoke & Moss Shave Kit",           price:"$114", variantId:"45634502328470", handle:"smoke-moss-shave-kit-5-pieces", img:CDN+"files/ShaveKit-SmokeandMoss1_1.png?v=1758353866"},
                pc:{title:"Peppermint & Cedarwood Shave Kit", price:"$114", variantId:"45634483388566", handle:"peppermint-cedarwood-shave-kit-5-pieces", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Shave Kit",             price:"$114", variantId:"45624990204054", handle:"unscented-shave-kit-5-pieces", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    // "Simple" gift-budget tier: a single hero product at full price.
    beardOil:{ collection:"beard", fallback:{title:"Beard Oil (30ml)", price:"$33", variantId:"32942290632841", handle:"bergamot-grapefruit", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
      byScent:{ bg:{title:"Bergamot Grapefruit Beard Oil (30ml)", price:"$33", variantId:"32942290632841", handle:"bergamot-grapefruit", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
                be:{title:"Balsam Eclipse Beard Oil (30ml)",       price:"$33", variantId:"31869019586697", handle:"balsam-eclipse", img:CDN+"files/fyf-rec-beardkit-be.pngfyf-rec-beardkit-be.png?v=1785862509"},
                sm:{title:"Smoke & Moss Beard Oil (30ml)",         price:"$33", variantId:"42897034870934", handle:"smoke-and-moss-beard-oil-30ml-1fl-oz", img:CDN+"files/SmokeandMoss_Smokebackground.png?v=1700101619"},
                pc:{title:"Peppermint Cedarwood Beard Oil (30ml)", price:"$33", variantId:"43592989769878", handle:"peppermint-cedarwood-4", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Beard Oil (30ml)",            price:"$33", variantId:"40029526261910", handle:"unscented", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    beardOilMini:{ collection:"beard", fallback:{title:"Beard Oil (10ml)", price:"$16.50", variantId:"32942290600073", handle:"bergamot-grapefruit-1", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
      byScent:{ bg:{title:"Bergamot Grapefruit Beard Oil (10ml)", price:"$16.50", variantId:"32942290600073", handle:"bergamot-grapefruit-1", img:CDN+"files/fyf-rec-beardkit-bg.png?v=1785862509"},
                be:{title:"Balsam Eclipse Beard Oil (10ml)",       price:"$16.50", variantId:"31869017194633", handle:"balsam-eclipse-1", img:CDN+"files/fyf-rec-beardkit-be.pngfyf-rec-beardkit-be.png?v=1785862509"},
                sm:{title:"Smoke & Moss Beard Oil (10ml)",         price:"$16.50", variantId:"42925100630166", handle:"smoke-moss-beard-oil-10ml-34fl-oz", img:CDN+"files/SmokeandMoss_Smokebackground.png?v=1700101619"},
                pc:{title:"Peppermint Cedarwood Beard Oil (10ml)", price:"$16.50", variantId:"32942293352585", handle:"peppermint-cedarwood-1", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Beard Oil (10ml)",            price:"$16.50", variantId:"40970824646806", handle:"copy-of-bergamot-grapefruit-beard-oil-10ml-34fl-oz", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    shaveSoap:{ collection:"shave-1", fallback:{title:"Shave Soap", price:"$28", variantId:"42643831816342", handle:"bergamot-grapefruit-shave-soap-114g-4oz", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"},
      byScent:{ bg:{title:"Bergamot & Grapefruit Shave Soap", price:"$28", variantId:"42643831816342", handle:"bergamot-grapefruit-shave-soap-114g-4oz", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"},
                be:{title:"Balsam Eclipse Shave Soap",         price:"$28", variantId:"42643845415062", handle:"balsam-eclipse-shave-soap-114g-4oz", img:CDN+"files/ShaveKit-BalsamEclipse1.png?v=1758355366"},
                sm:{title:"Smoke & Moss Shave Soap",           price:"$28", variantId:"42897134059670", handle:"smoke-moss-shave-soap-114g-4oz", img:CDN+"files/ShaveKit-SmokeandMoss1_1.png?v=1758353866"},
                pc:{title:"Peppermint Cedarwood Shave Soap",   price:"$28", variantId:"42639240298646", handle:"peppermint-cedarwood-shave-soap-114g-4oz", img:CDN+"files/PC_1600_x_2000_portrait.png?v=1783878595"},
                un:{title:"Unscented Shave Soap",              price:"$28", variantId:"42643858227350", handle:"unscented-shave-soap-114g-4oz", img:CDN+"files/unscented_1600_x_2000_portrait.png?v=1783878595"} } },
    // Shave tools (no scent) for the shave budget ladder.
    brush:{ collection:"shave-1", byScent:null, fallback:{title:"Badger Shave Brush", price:"$36", variantId:"45625664340118", handle:"badger-shave-brush", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"} },
    razor:{ collection:"shave-1", byScent:null, fallback:{title:"Safety Razor with Stand & 10 Blades", price:"$79", variantId:"45625232392342", handle:"safety-razor-with-stand-10-blades", img:CDN+"files/fyf-rec-shavekit-bg.png?v=1785862509"} },
    // Hair = the one Confident Hold Pomade at full price. No scent choice (only 1 pomade).
    hair:{ collection:"hair", byScent:null, fallback:{title:"Confident Hold Pomade", price:"$33", variantId:"40495549710486", handle:"pomade", img:CDN+"files/pomade_portait.png?v=1783904340"} }
  };

  /* =========================================================================
     QUESTIONS
       track: "both" | "self" | "gift"   -> which flow it appears in
       focus: "beard"|"shave"|"hair"|"all" -> only shows once that focus is chosen
       setFocus on an option locks the topic for every question after it
       serious:true marks a committed beard grower (gets the Book of Beards)
     ========================================================================= */
  var questions = [
    { id:"forwho", track:"both", variantId:"A",
      q:"First, who is this for?",
      options:[
        {label:"Myself",     forWho:"self"},
        {label:"It's a gift", forWho:"gift"}
      ] },

    { id:"situation", track:"both",
      // A/B TEST (seed). Add a `variants` array to ANY question to split-test it.
      // A visitor is randomly shown one; which one rides along on every event.
      // The quarterly agent promotes the winner and writes a fresh challenger.
      variants:[
        { q:"Where should we focus?", options:[
          {label:"The beard", setFocus:"beard"},
          {label:"The shave", setFocus:"shave"},
          {label:"The hair",  setFocus:"hair"},
          {label:"All of it", setFocus:"all"}
        ]},
        { q:"What matters most to you?", options:[
          {label:"The beard", setFocus:"beard"},
          {label:"The shave", setFocus:"shave"},
          {label:"The hair",  setFocus:"hair"},
          {label:"All of it", setFocus:"all"}
        ]}
      ] },

    /* ---------- BEARD branch (self) ---------- */
    { id:"beard_len", track:"self", focus:"beard", variantId:"A",
      q:"How long is the beard right now?",
      options:[
        {label:"Just stubble"},
        {label:"Short and filling in"},
        {label:"Full and thick"},
        {label:"Long. I'm growing it out.", serious:true}
      ] },
    { id:"beard_goal", track:"self", focus:"beard", variantId:"A",
      q:"And what would make it better?",
      options:[
        {label:"Softer, less itch"},
        {label:"Better shape and control"},
        {label:"Healthy growth over time"},
        {label:"The complete routine, all of it", serious:true}
      ] },

    /* ---------- SHAVE branch (self) ---------- */
    { id:"shave_how", track:"self", focus:"shave", variantId:"A",
      q:"How do you shave now?",
      options:[
        {label:"Cartridge razor"},
        {label:"Safety or straight razor"},
        {label:"Electric"},
        {label:"Just getting started"}
      ] },
    { id:"shave_goal", track:"self", focus:"shave", variantId:"A",
      q:"And what are you after?",
      options:[
        {label:"A closer shave"},
        {label:"Less razor burn"},
        {label:"Fewer nicks"},
        {label:"A shave worth slowing down for"}
      ] },

    /* ---------- HAIR branch (self) ---------- */
    { id:"hair_wear", track:"self", focus:"hair", variantId:"A",
      q:"How do you wear it?",
      options:[
        {label:"Short and simple"},
        {label:"Styled, with some hold"},
        {label:"Longer, needs taming"},
        {label:"Thinning, want to look after it"}
      ] },
    { id:"hair_goal", track:"self", focus:"hair", variantId:"A",
      q:"And what are you after?",
      options:[
        {label:"A clean, natural hold"},
        {label:"Less dry and frizzy"},
        {label:"The right brush and comb"},
        {label:"A bit of everything"}
      ] },

    /* ---------- ALL OF IT branch (self) ---------- */
    { id:"all_routine", track:"self", focus:"all", variantId:"A",
      q:"What's your routine like now?",
      options:[
        {label:"Quick, in and out"},
        {label:"I take my time with it"},
        {label:"Honestly, all over the place"},
        {label:"Building a real one", serious:true}
      ] },
    { id:"all_first", track:"self", focus:"all", variantId:"A",
      q:"If we sorted one thing first?",
      options:[
        {label:"The beard"},
        {label:"The shave"},
        {label:"The hair"},
        {label:"Everything, together", serious:true}
      ] },

    /* ---------- GIFT branch: budget ladder (after focus). Hair = one pomade, no budget step. ---------- */
    { id:"giftbudget", track:"gift", variantId:"A",
      q:"What's your budget?",
      sub:"You can upgrade for a bit more on the next screen.",
      options:[
        {label:"$10 - $30",  budget:"r1"},
        {label:"$31 - $50",  budget:"r2"},
        {label:"$51 - $100", budget:"r3"},
        {label:"$100+",      budget:"r4"}
      ] },

    /* ---------- BOTH: scent ---------- */
    { id:"scent", track:"both", isScent:true, variantId:"A",
      q:"Last one. Pick a scent.",
      options:[
        {label:SCENTS.bg.label, note:SCENTS.bg.note, scent:"bg"},
        {label:SCENTS.be.label, note:SCENTS.be.note, scent:"be"},
        {label:SCENTS.sm.label, note:SCENTS.sm.note, scent:"sm"},
        {label:SCENTS.pc.label, note:SCENTS.pc.note, scent:"pc"},
        {label:SCENTS.un.label, note:SCENTS.un.note, scent:"un"}
      ] }
  ];

  /* Result copy. Grade 4-5, brand voice, one proof line, one clear CTA. */
  var COPY = {
    beard:{badge:"Your fit: Beard",
      h:"A better beard is three steps, not thirty.",
      p:"The itch and the flakes come from a dry beard. Your skin stopped making enough oil to keep up with the hair. The kit puts it back: wash, oil, then butter. A few minutes a day, and the beard goes soft.",
      edu:"The itch is not your fault, it is dryness. Your face makes very little oil, and a growing beard drinks what little there is. The oil puts it back."},
    shave:{badge:"Your fit: Shave",
      h:"You should not have to pick between close and comfortable.",
      p:"Burn and nicks come from a blade dragging on skin with no real cushion. A thick lather from soap and a brush lifts each hair and guards the skin under it. Same shave, none of the sting.",
      edu:"Canned foam just sits on top of the hair. A real lather gets under it, lifts each hair, and cushions the blade. That is what stops the burn."},
    hair:{badge:"Your fit: Hair",
      h:"A hold that works with you, not against you.",
      p:"Stiff, crunchy, and greasy is old-school product. Our Confident Hold Pomade shapes your hair and keeps it there all day, soft enough to run your fingers through.",
      edu:"A little goes a long way. Warm a pea-size amount between your fingers, then work it from the back first and the front last, so the front never turns greasy."},
    bookSelf:{badge:"Your fit: The Full Kit",
      h:"You are all in. So is this.",
      p:"You did not pick one thing, and that is the point. The Book of Beards® holds the whole routine: oil, wash, balm, wax, and the tools, in a box that is an actual book. Everything your beard needs, in the scent you chose.",
      edu:"Every bottle is amber glass for a reason. It keeps light and air out, so the organic oils stay good for a full year after you open them."},
    giftBook:{badge:"The gift: Book of Beards®",
      h:"The gift he opens twice.",
      p:"The box is an actual book, so it lands before he even lifts the cover. Inside is the whole routine: oil, wash, balm, wax, and the tools. He will get it the moment he opens it.",
      edu:"The book is made to keep, long after the products run out. Inside, everything is amber glass to protect the organic oils."},
    giftBeardKit:{badge:"The gift: Beard Kit",
      h:"Simple to give. Easy to use.",
      p:"Three steps, no guesswork: wash, oil, butter. It softens the beard and calms the itch from the first week. The kind of gift he reaches for every morning, not one that sits on a shelf.",
      edu:"The order is the secret: wash, then oil, then butter. Clean first, feed the skin, then lock it all in."},
    giftBeardOil:{badge:"The gift: Beard Oil",
      h:"The daily essential, beautifully done.",
      p:"One good beard oil is where every routine starts. A few drops soften the beard, calm the itch, and leave a clean scent. Simple, and he will use it every morning.",
      edu:"A few drops is all it takes. Warm it in the palms and work it from the skin out, so the whole beard gets it, not just the surface."},
    giftShaveSoap:{badge:"The gift: Shave Soap",
      h:"The upgrade he did not know he needed.",
      p:"Swap the canned foam for a real soap and a brush. It builds a dense, slick lather that cushions the blade, so the shave gets closer and the burn goes away.",
      edu:"Two minutes with a brush and warm water is the whole trick. The lather lifts the hair and protects the skin under it."},
    giftBrush:{badge:"The gift: Shave Brush",
      h:"The piece that makes the lather work.",
      p:"A badger brush whips soap and warm water into a dense, warm lather and lifts every hair before the blade. The small upgrade that turns a shave into a ritual.",
      edu:"Load the brush, then paint it on in slow circles. The bristles lift the hair and hold the water that softens it."},
    giftRazor:{badge:"The gift: Safety Razor",
      h:"One blade. A closer, cleaner shave.",
      p:"A weighted safety razor with a stand and ten blades. One sharp blade instead of five dragging ones means less irritation and fewer ingrowns, and refills cost pennies.",
      edu:"Let the weight do the work. No pressure, short strokes, with the grain first."},
    giftShave:{badge:"The gift: Shave Kit",
      h:"Turn his worst chore into his best ten minutes.",
      p:"Five pieces that make shaving feel like something, not a rush before work. A brush, a soap that builds a real lather, and the hardware to do it right. He will feel it on the first pass.",
      edu:"The lather is the whole trick. It softens the hair and cushions the blade, so close and comfortable stop fighting each other."},
    giftHair:{badge:"The gift: Hair",
      h:"A clean, simple gift he uses daily.",
      p:"Our Confident Hold Pomade: a soft, all-day hold that styles easy and never turns crunchy. One product, no fuss, and he reaches for it every morning.",
      edu:"A little goes a long way. A pea-size amount, worked from the back first and the front last, keeps the front from going greasy."}
  };
  var TRUST = "Certified organic. Made by us in Canada.";

  /* =========================================================================
     STATE + FLOW
     ========================================================================= */
  var state = { step:0, track:"self", forWho:"self", focus:"beard", scent:"bg", serious:false, giftTier:"premium", giftProduct:null, answers:{} };
  var stage = document.getElementById("fyf-stage");

  // A question shows if its track matches, and (if it has a focus) that focus is active.
  function active(){
    return questions.filter(function(q){
      if(!(q.track==="both" || q.track===state.track)) return false;
      if(q.focus && q.focus!==state.focus) return false;
      // No scent step where scent doesn't apply: hair (one pomade), and the
      // scent-agnostic shave tools (brush, razor).
      if(q.isScent && (state.focus==="hair" || state.giftProduct==="brush" || state.giftProduct==="razor")) return false;
      // Hair is one pomade, no budget step.
      if(q.id==="giftbudget" && state.focus==="hair") return false;
      return true;
    });
  }

  // ---- A/B variants ----
  // On open, each question with a `variants` array is randomly assigned one.
  function assignVariants(){
    questions.forEach(function(q){
      if(q.variants && q.variants.length){
        state.variantMap[q.id] = Math.floor(Math.random()*q.variants.length);
      }
    });
  }
  // Merge the chosen variant's fields over the question for rendering.
  function effective(q){
    if(!q.variants) return q;
    var idx = state.variantMap[q.id] || 0;
    var v = q.variants[idx] || q.variants[0];
    return { id:q.id, isScent:q.isScent, track:q.track, focus:q.focus, q:v.q, sub:v.sub, options:v.options };
  }
  function variantLabelFor(id){
    return state.variantMap[id]===undefined ? "" : String.fromCharCode(65 + state.variantMap[id]); // 0->A
  }
  function variantsSnapshot(){
    var o={}; Object.keys(state.variantMap||{}).forEach(function(id){ o[id]=variantLabelFor(id); }); return o;
  }
  // Every option across all variants (used when reversing scoring on Back).
  function allOptions(q){
    if(!q.variants) return q.options;
    var out=[]; q.variants.forEach(function(v){ (v.options||[]).forEach(function(o){ out.push(o); }); }); return out;
  }

  // Anonymous funnel event -> eb-app. Fire-and-forget, never blocks the quiz.
  function postEvent(event, extra){
    if(!CONFIG.trackUrl) return;
    var payload = { session:state.session, event:event, variants:variantsSnapshot() };
    if(extra){ Object.keys(extra).forEach(function(k){ payload[k]=extra[k]; }); }
    try{
      fetch(CONFIG.trackUrl, { method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify(payload), keepalive:true, mode:"cors" }).catch(function(){});
    }catch(e){}
  }

  function track(event, props){
    try{ if(window.fbq){ window.fbq("trackCustom", event, props||{}); } }catch(e){}
    try{ if(window._learnq){ window._learnq.push(["track", event, props||{}]); } }catch(e){}
  }

  function renderQuestion(){
    var list = active();
    var total = list.length;
    var qi = state.step;
    var qq = effective(list[qi]);
    var pct = Math.round((qi/total)*100);

    var opts = qq.options.map(function(opt, idx){
      var note = opt.note ? '<div class="fyf-opt-note">'+opt.note+'</div>' : '';
      return '<button class="fyf-opt" data-idx="'+idx+'"><span>'+opt.label+note+'</span>'+
             '<span class="fyf-chev">&rsaquo;</span></button>';
    }).join("");

    var hero = (qi===0 && CONFIG.heroImage) ? '<img class="fyf-hero" src="'+CONFIG.heroImage+'" alt="">' : '';
    stage.innerHTML =
      hero+
      '<div class="fyf-progwrap"><p class="fyf-kicker">Find Your Fit</p>'+
        '<div class="fyf-progbar"><div class="fyf-progfill" style="width:'+pct+'%"></div></div>'+
        '<div class="fyf-progtext">Question '+(qi+1)+' of '+total+'</div></div>'+
      '<h2 class="fyf-q">'+qq.q+'</h2>'+
      (qq.sub? '<p class="fyf-sub">'+qq.sub+'</p>':'')+
      '<div class="fyf-opts">'+opts+'</div>'+
      '<div class="fyf-nav"><button class="fyf-back" '+(qi===0?'disabled':'')+'>&lsaquo; Back</button><span></span></div>';

    Array.prototype.forEach.call(stage.querySelectorAll(".fyf-opt"), function(btn){
      btn.addEventListener("click", function(){ choose(qq, parseInt(btn.getAttribute("data-idx"),10)); });
    });
    stage.querySelector(".fyf-back").addEventListener("click", back);
  }

  function choose(qq, idx){
    var opt = qq.options[idx];
    state.answers[qq.id] = opt.label;
    if(qq.id==="forwho"){ state.forWho = opt.forWho; state.track = opt.forWho; }
    if(opt.setFocus){ state.focus = opt.setFocus; }
    if(qq.isScent){ state.scent = opt.scent; }
    if(opt.giftTier){ state.giftTier = opt.giftTier; }
    if(opt.giftProduct){ state.giftProduct = opt.giftProduct; }
    // Budget range -> product, by focus. Beard/all ladder vs shave ladder.
    if(opt.budget){
      state.budget = opt.budget;
      var LADDER = {
        beard: { r1:"beardOilMini", r2:"beardOil", r3:"beardKit", r4:"book" },
        all:   { r1:"beardOilMini", r2:"beardOil", r3:"beardKit", r4:"book" },
        shave: { r1:"shaveSoap",    r2:"brush",    r3:"razor",    r4:"shaveKit" }
      };
      var m = LADDER[state.focus] || LADDER.beard;
      state.giftProduct = m[opt.budget] || "beardKit";
    }
    recomputeSerious();
    track("FYF_Answer", {question:qq.id, choice:opt.label, forWho:state.forWho, focus:state.focus});
    postEvent("answer", { questionId:qq.id, variant:variantLabelFor(qq.id), choice:opt.label, forWho:state.forWho, focus:state.focus });
    state.step++;
    if(state.step < active().length){ renderQuestion(); } else { renderResult(); }
  }

  // Serious flag is derived from whatever is currently answered, so Back stays correct.
  function recomputeSerious(){
    state.serious = false;
    Object.keys(state.answers).forEach(function(id){
      var q = questions.filter(function(x){return x.id===id;})[0];
      if(!q) return;
      var o = allOptions(q).filter(function(op){return op.label===state.answers[id];})[0];
      if(o && o.serious) state.serious = true;
    });
  }

  function back(){
    if(state.step===0) return;
    state.step--;
    var qq = active()[state.step];
    if(qq) delete state.answers[qq.id];
    recomputeSerious();
    renderQuestion();
  }

  /* -------- decide the recommendation -------- */
  function buildRec(prod){
    // Use the exact-scent product when one exists; otherwise send them to the
    // collection (e.g. scents with no assembled kit) rather than mislabel it.
    var chosen = (prod.byScent && prod.byScent[state.scent]) ? prod.byScent[state.scent] : prod.fallback;
    var url = chosen && chosen.handle ? CONFIG.storeUrl+"/products/"+chosen.handle
                                      : CONFIG.storeUrl+"/collections/"+prod.collection;
    return {rec:chosen, url:url};
  }

  // Gift product key -> result copy block.
  function giftCopyFor(key){
    if(key==="beardOilMini" || key==="beardOil") return "giftBeardOil";
    if(key==="beardKit") return "giftBeardKit";
    if(key==="book") return "giftBook";
    if(key==="shaveSoap") return "giftShaveSoap";
    if(key==="brush") return "giftBrush";
    if(key==="razor") return "giftRazor";
    return "giftShave"; // shaveKit
  }
  // "For a bit more" one-tap upgrade target for each gift-budget pick.
  var UPGRADE = { beardOilMini:"beardOil", beardOil:"beardKit", beardKit:"book", shaveSoap:"shaveKit", brush:"shaveKit", razor:"shaveKit" };
  // Bundle savings vs buying the pieces separately (shown in the upsell).
  var SAVES = { shaveKit:"29" };

  function priceNum(p){ return parseFloat(String(p||"").replace(/[^0-9.]/g,"")) || 0; }

  function resolve(){
    var copyKey, prod, giftKey=null;
    if(state.forWho==="gift"){
      if(state.focus==="hair"){ copyKey="giftHair"; prod=PRODUCTS.hair; }
      else {
        giftKey = state.giftProduct || (state.focus==="shave" ? "shaveKit" : state.focus==="all" ? "book" : "beardKit");
        prod = PRODUCTS[giftKey] || PRODUCTS.beardKit;
        copyKey = giftCopyFor(giftKey);
      }
    } else {
      if(state.focus==="shave"){ copyKey="shave"; prod=PRODUCTS.shaveKit; }
      else if(state.focus==="hair"){ copyKey="hair"; prod=PRODUCTS.hair; }
      else if(state.focus==="all"){ copyKey="bookSelf"; prod=PRODUCTS.book; }
      else { // beard
        if(state.serious){ copyKey="bookSelf"; prod=PRODUCTS.book; }
        else { copyKey="beard"; prod=PRODUCTS.beardKit; }
      }
    }
    var built = buildRec(prod);
    var result = {copyKey:copyKey, copy:COPY[copyKey], rec:built.rec, url:built.url};
    // Value line when the pick IS the Shave Kit (bundles the pieces for $29 less).
    if(prod===PRODUCTS.shaveKit){ result.savesNote = "The Shave Kit is $29 less than the soap, brush and razor bought separately."; }
    // Gift upsell: one-tap "make it the ..." for a bit more.
    if(giftKey && UPGRADE[giftKey]){
      var up = buildRec(PRODUCTS[UPGRADE[giftKey]]);
      var diff = priceNum(up.rec.price) - priceNum(built.rec.price);
      var diffStr = (diff % 1 === 0) ? String(diff) : diff.toFixed(2);
      if(up.rec.variantId && diff > 0){
        result.upgrade = { rec:up.rec, url:up.url, diff:diffStr, saves:SAVES[UPGRADE[giftKey]]||null, copyKey:giftCopyFor(UPGRADE[giftKey]) };
      }
    }
    return result;
  }

  function renderResult(){
    var r = resolve();
    var isGift = state.forWho==="gift";
    var scentLabel = SCENTS[state.scent] ? SCENTS[state.scent].label : "";
    var noScentPick = state.focus==="hair" || state.giftProduct==="brush" || state.giftProduct==="razor";
    var showScent = scentLabel && state.scent!=="un" && !noScentPick && r.rec && r.rec.handle;
    track("FYF_Result", {copyKey:r.copyKey, forWho:state.forWho, focus:state.focus, scent:state.scent});
    postEvent("result", { result:r.copyKey, audience:audienceOf(r.copyKey), forWho:state.forWho, focus:state.focus, scent:state.scent });

    var offer = CONFIG.incentive ? (" "+CONFIG.incentive) : "";
    var canCart = !!(r.rec && r.rec.variantId);
    // Primary action = Add to cart (drives revenue). Falls back to "Shop the
    // collection" for picks with no single variant (hair, and pc/un scents).
    var primary = canCart
      ? '<button class="fyf-btn" id="fyf-add">Add to cart'+(r.rec.price? " &middot; "+r.rec.price : "")+'</button>'
      : '<a class="fyf-btn" href="'+r.url+'" style="display:block;text-align:center;text-decoration:none">Shop the '+(isGift?"gift":"collection")+'</a>';

    stage.innerHTML =
      '<span class="fyf-result-badge">'+r.copy.badge+'</span>'+
      '<h2 class="fyf-result-h">'+r.copy.h+'</h2>'+
      '<p class="fyf-result-p">'+r.copy.p+'</p>'+
      (r.copy.edu? '<p class="fyf-edu">'+r.copy.edu+'</p>' : '')+
      '<div class="fyf-rec">'+(r.rec.img? '<img class="fyf-rec-img" src="'+r.rec.img+'" alt="">':'')+'<div class="fyf-rec-body"><h4>'+r.rec.title+'</h4>'+
        '<p>'+(showScent? "Scent: "+scentLabel : "Ready to go")+'</p></div>'+
        '<div class="fyf-rec-price">'+(r.rec.price||"")+'</div></div>'+
      '<p class="fyf-trust">'+TRUST+'</p>'+
      (r.savesNote? '<p class="fyf-edu">'+r.savesNote+'</p>' : '')+
      primary+
      (r.upgrade ? '<button class="fyf-btn secondary" id="fyf-upsell" style="margin-top:10px">Upgrade to '+r.upgrade.rec.title+' &middot; +$'+r.upgrade.diff+'</button>'+
        (r.upgrade.saves? '<p class="fyf-consent" style="margin-top:6px">Buy the soap, brush and razor on their own and you would pay $'+r.upgrade.saves+' more. The kit bundles them.</p>':'') : '')+
      '<form class="fyf-form" id="fyf-form" style="margin-top:12px">'+
        '<input class="fyf-input" type="email" id="fyf-email" placeholder="Prefer we email your results? Enter your email'+offer+'">'+
        '<div class="fyf-err" id="fyf-err"></div>'+
        '<button class="fyf-btn secondary" type="submit">Email me my results</button>'+
        '<p class="fyf-consent">We will email your result and the odd good thing. Leave anytime.</p>'+
      '</form>';

    if(canCart){ document.getElementById("fyf-add").addEventListener("click", function(){ addToCart(r); }); }
    if(r.upgrade){ var upEl=document.getElementById("fyf-upsell"); if(upEl){ upEl.addEventListener("click", function(){
      addToCart({ copyKey:r.upgrade.copyKey, copy:COPY[r.upgrade.copyKey], rec:r.upgrade.rec, url:r.upgrade.url });
    }); } }
    document.getElementById("fyf-form").addEventListener("submit", function(e){ e.preventDefault(); submitLead(r); });
  }

  // Primary conversion action: add the recommended kit to the Shopify cart,
  // fire the Meta "AddToCart" pixel (so ads optimize toward buyers), log the
  // event, capture the email too if one was typed, then go to the cart.
  function addToCart(r){
    var vid = r.rec && r.rec.variantId;
    if(!vid){ window.location.href = r.url; return; }
    var priceNum = parseFloat(String(r.rec.price||"").replace(/[^0-9.]/g,"")) || 0;
    try{ if(window.fbq){ window.fbq("track","AddToCart",{content_ids:[r.rec.handle||vid], content_type:"product", value:priceNum, currency:"CAD"}); } }catch(e){}
    postEvent("addtocart", { result:r.copyKey, audience:audienceOf(r.copyKey), forWho:state.forWho, focus:state.focus, scent:state.scent });
    var email = (((document.getElementById("fyf-email")||{}).value)||"").trim();
    if(/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email) && CONFIG.klaviyo.companyId && listFor(r.copyKey)){
      try{ subscribeKlaviyo(email, r).catch(function(){}); }catch(e){}
    }
    // Success: close the quiz and open the UpCart slide cart (with its perks).
    // We deliberately do NOT send the shopper to the /cart page.
    var openSlideCart = function(){
      try{ closeQuiz(); }catch(e){}
      try{ if(typeof window.upcartRefreshCart === "function"){ window.upcartRefreshCart(); } }catch(e){}
      try{ if(typeof window.upcartOpenCart === "function"){ window.upcartOpenCart(); return; } }catch(e){}
      // Fallback only if the UpCart drawer isn't on the page for some reason.
      window.location.href = "/cart";
    };
    var permalink = function(){ window.location.href = CONFIG.storeUrl + "/cart/" + vid + ":1"; };
    try{
      fetch("/cart/add.js", { method:"POST", headers:{"Content-Type":"application/json"},
        body:JSON.stringify({ items:[{ id:Number(vid), quantity:1 }] }) })
        .then(function(res){ if(!res.ok) throw 0; return res.json(); })
        .then(openSlideCart).catch(permalink);
    }catch(e){ permalink(); }
  }

  // Which audience bucket a result belongs to (drives list + segmentation).
  function audienceOf(copyKey){
    if(copyKey==="beard") return "beard";
    if(copyKey==="shave") return "shave";
    if(copyKey==="hair")  return "hair";
    if(copyKey==="bookSelf") return "full";
    return "gift"; // giftBook, giftBeardKit, giftShave, giftHair
  }
  // Use the audience's own list if one is set, otherwise the default list.
  function listFor(copyKey){
    var a = audienceOf(copyKey);
    return (CONFIG.klaviyo.lists && CONFIG.klaviyo.lists[a]) || CONFIG.klaviyo.listId;
  }

  function submitLead(r){
    var email = (document.getElementById("fyf-email").value||"").trim();
    var errEl = document.getElementById("fyf-err");
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ errEl.textContent = "That email looks off. Mind checking it?"; return; }
    errEl.textContent = "";
    track("FYF_Lead", {copyKey:r.copyKey, audience:audienceOf(r.copyKey), forWho:state.forWho, focus:state.focus, scent:state.scent});
    postEvent("lead", { result:r.copyKey, audience:audienceOf(r.copyKey), forWho:state.forWho, focus:state.focus, scent:state.scent });
    var done = function(){ window.location.href = r.url; };
    if(CONFIG.klaviyo.companyId && listFor(r.copyKey)){ subscribeKlaviyo(email, r).then(done).catch(done); }
    else { console.warn("[FindYourFit] Klaviyo not set — add CONFIG.klaviyo.companyId + a list id."); done(); }
  }

  function subscribeKlaviyo(email, r){
    var payload = { data:{ type:"subscription",
      attributes:{
        custom_source:"Find Your Fit Quiz",
        profile:{ data:{ type:"profile", attributes:{
          email:email,
          subscriptions:{ email:{ marketing:{ consent:"SUBSCRIBED" } } },
          properties:{
            FYF_Result:r.copyKey,
            FYF_Audience:audienceOf(r.copyKey),
            FYF_ForWho:state.forWho,
            FYF_Focus:state.focus,
            FYF_Scent:state.scent
          }
        }}}
      },
      relationships:{ list:{ data:{ type:"list", id:listFor(r.copyKey) }}} } };
    return fetch("https://a.klaviyo.com/client/subscriptions/?company_id="+encodeURIComponent(CONFIG.klaviyo.companyId),{
      method:"POST", headers:{ "Content-Type":"application/json", "revision":"2024-10-15" }, body:JSON.stringify(payload) });
  }

  /* -------- open / close the pop-up -------- */
  function resetState(){
    state = { step:0, track:"self", forWho:"self", focus:"beard", scent:"bg", serious:false, giftTier:"premium", giftProduct:null, answers:{},
      session:"fyf_"+Date.now().toString(36)+Math.random().toString(36).slice(2,8), variantMap:{} };
    assignVariants();
  }
  var overlay = document.getElementById("fyf-overlay");
  // Optional `focus` deep-links a category button straight into that branch
  // (skips "who is this for" + "where should we focus"): openFindYourFit('beard').
  function openQuiz(focus){
    resetState();
    if(typeof focus==="string" && /^(beard|shave|hair|all)$/.test(focus)){
      state.forWho="self"; state.track="self"; state.focus=focus;
      state.answers.forwho="Myself";
      state.answers.situation = (focus==="all" ? "All of it" : "The "+focus);
      state.step = 2; // jump past the who/where questions to the branch
    }
    overlay.hidden=false; document.body.style.overflow="hidden";
    renderQuestion(); track("FYF_Open",{focus:focus||null}); postEvent("open", focus?{forWho:"self",focus:focus}:null);
  }
  function closeQuiz(){ overlay.hidden=true; document.body.style.overflow=""; }

  var trigger = document.getElementById("fyf-trigger");
  if(trigger) trigger.addEventListener("click", openQuiz);
  document.getElementById("fyf-close").addEventListener("click", closeQuiz);
  overlay.addEventListener("click", function(e){ if(e.target===overlay) closeQuiz(); });
  document.addEventListener("keydown", function(e){ if(e.key==="Escape" && !overlay.hidden) closeQuiz(); });

  // Wire your own button/nav link to this to open the quiz:
  window.openFindYourFit = openQuiz;
})();
 })(); }catch(e){ if(window.console)console.error('FYF quiz error',e); }
    try{ (function(){ (function(){
  "use strict";
  var TITLE_TEXT = "YOUR ROUTINE";           // your hero title (case-insensitive)
  var TITLE_SELECTOR = ".carousel-caption-title"; // tried first; falls back to text match

  function findTitle(){
    var t = document.querySelector(TITLE_SELECTOR);
    if(t) return t;
    var els = Array.prototype.slice.call(document.querySelectorAll("h1,h2,h3,p,span,div"));
    return els.filter(function(e){
      return e.children.length===0 && e.textContent &&
             e.textContent.trim().toUpperCase() === TITLE_TEXT.toUpperCase();
    })[0] || null;
  }

  // Always-visible "Take the Quiz" pill (bottom-center, clear of the chat +
  // UpCart buttons). Guarantees the quiz is reachable on every page this loads
  // on, and it never disappears on scroll.
  function ensureSticky(){
    if(document.getElementById("fyf-sticky") || !document.body) return;
    // Show only on marketing surfaces: homepage, any /pages/ page (Find Your
    // Fit, Routine, ...), and the blog. Not on products, collections, cart, etc.
    var p = (location.pathname || "").toLowerCase();
    if(!(p === "/" || p.indexOf("/pages/") === 0 || p.indexOf("/blogs/") === 0)) return;
    var b = document.createElement("button");
    b.id = "fyf-sticky"; b.className = "fyf-sticky"; b.type = "button";
    b.textContent = "Take the Quiz";
    b.addEventListener("click", function(){
      if(typeof window.openFindYourFit === "function"){ window.openFindYourFit(); }
    });
    document.body.appendChild(b);
  }

  function install(){
    if(document.getElementById("fyf-entry")) return true;
    // Hero buttons (Beard | Hair | Shave over the image) only where the hero
    // title exists — homepage + Find Your Routine. Other pages just get the
    // sticky pill above.
    var p = (location.pathname || "").toLowerCase();
    if(!(p === "/" || p.indexOf("find-your") !== -1 || p.indexOf("routine") !== -1)) return true;
    var title = findTitle();
    if(!title) return false;
    var wrap = document.createElement("div");
    wrap.id = "fyf-entry"; wrap.className = "fyf-entry";
    wrap.innerHTML =
      '<p class="fyf-entry-cats">'+
        '<a href="#" data-fyf="beard">Beard</a><span>|</span>'+
        '<a href="#" data-fyf="hair">Hair</a><span>|</span>'+
        '<a href="#" data-fyf="shave">Shave</a>'+
      '</p>'+
      '<button type="button" class="fyf-entry-cta" data-fyf="">Find Your Routine</button>';
    title.parentNode.insertBefore(wrap, title.nextSibling);
    // Position the hero caption. The theme bottom-aligns it (right over the
    // model's face). Center it and lift ~15% of the hero's own height so the
    // whole block (title + Beard/Hair/Shave + button) sits high, clustered in
    // the upper/grey area and ALWAYS clear of the model's face. A CSS percentage
    // is relative to the element's height, so it scales across screen sizes.
    var cap = title.closest && title.closest(".carousel-caption");
    if(cap){
      cap.style.alignItems = "center";
      cap.style.transform = "translateY(-15%)";
    }
    // Strong shadow so the white title reads whether it lands on snow or grey.
    title.style.textShadow = "0 2px 18px rgba(0,0,0,.85), 0 1px 4px rgba(0,0,0,.95)";
    wrap.addEventListener("click", function(e){
      var el = e.target.closest && e.target.closest("[data-fyf]");
      if(!el) return;
      e.preventDefault();
      var focus = el.getAttribute("data-fyf");
      if(typeof window.openFindYourFit === "function"){ window.openFindYourFit(focus || undefined); }
    });
    return true;
  }

  function boot(){ ensureSticky(); install(); }
  if(document.readyState !== "loading"){ boot(); }
  else { document.addEventListener("DOMContentLoaded", boot); }
  // Slideshow captions can mount late — retry briefly until the title exists.
  var tries = 0;
  var iv = setInterval(function(){ ensureSticky(); if(install() || tries++ > 25){ clearInterval(iv); } }, 300);
})();
 })(); }catch(e){ if(window.console)console.error('FYF buttons error',e); }
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();
